import { Header, PageContent, PageHeader, Spacer } from "components";
import { FinancialTransactionsTable } from "financial/components/FinancialTransactionsTable";

export const FinancialTransactions = () => {
  return (
    <>
      <PageHeader>
        <Header title="Financial Transactions" subTitle="View and manage your financial transactions." />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={3} />
        <FinancialTransactionsTable />
      </PageContent>
    </>
  );
};
